import { AnimatedSection } from "@/components/common/AnimatedSection";
import { Search, FileText, MessageSquare, Plane } from "lucide-react";

const steps = [
  {
    icon: Search,
    title: "Choose Your Trip",
    description: "Browse our curated collection of tours, flight deals, and luxury cruise packages from around the world.",
  },
  {
    icon: FileText,
    title: "Request a Quote",
    description: "Tell us your travel dates, group size, and preferences. It takes less than a minute.",
  },
  {
    icon: MessageSquare,
    title: "Get a Custom Offer",
    description: "Our travel experts craft a personalized itinerary and pricing tailored exactly to you.",
  },
  {
    icon: Plane,
    title: "Book & Travel",
    description: "Confirm your booking and leave the rest to us. Just show up and enjoy your journey.",
  },
];

export const HowItWorks = () => {
  return (
    <section className="bg-surface-subtle section-padding" data-testid="how-it-works">
      <div className="container-wide px-4 sm:px-6 lg:px-8">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12">
            <p className="overline mb-3">Simple & Easy</p>
            <h2 className="heading-lg text-primary mb-4">How It Works</h2>
            <p className="text-base text-muted-foreground leading-relaxed">
              Planning your dream trip is easier than ever — four simple steps to your perfect getaway.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6 relative">
          {/* Connector line desktop only */}
          <div className="hidden lg:block absolute top-[28px] left-[12.5%] right-[12.5%] h-px border-t-2 border-dashed border-border z-0" />

          {steps.map((step, i) => (
            <AnimatedSection key={step.title} delay={i * 0.08}>
              <div className="relative flex flex-col items-center text-center z-10" data-testid={`step-${i + 1}`}>
                <div className="relative mb-5">
                  <div className="h-14 w-14 rounded-2xl bg-white shadow-sm flex items-center justify-center mx-auto">
                    <step.icon className="h-6 w-6 text-accent" />
                  </div>
                  <span className="absolute -top-1.5 -right-1.5 h-6 w-6 rounded-full bg-primary text-primary-foreground text-xs font-bold flex items-center justify-center shadow-sm">
                    {i + 1}
                  </span>
                </div>
                <h3 className="heading-xs text-primary mb-2">{step.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{step.description}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
};
